<template>
    <div role="button" data-toggle="modal" data-target="#vehicleDeliveryModal">
        <div class="d-flex">
            <div class="p-1">
                {{ this.availability }}
            </div>
            <div class="display-5 p-1">
                <i class="far fa-info-circle"></i>    
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AvailabilityModalButton",
        props: {
            availability: {
            type: String,
            required: true
            }
        },
    }
</script>